"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var SelloutItemFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutItemFilterConverter, _DataObjectConverter_);

  function SelloutItemFilterConverter() {
    _classCallCheck(this, SelloutItemFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutItemFilterConverter).apply(this, arguments));
  }

  return SelloutItemFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutItemFilterConverter = SelloutItemFilterConverter;